import React, { useState } from 'react';
import ButtonImportRecFed from '../../../../../../components/NovoSistema/ButtonImportRecFed';
import ButtonOptions from '../../../../../../components/NovoSistema/ButtonOptions';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import ButtonsPlusAndCheck from '../../../../../../components/NovoSistema/ButtonsPlusAndCheck';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../components/NovoSistema/DoubleInput';
import HeaderButtons from '../../../../../../components/NovoSistema/HeaderButtons';
import InputCheckBox from '../../../../../../components/NovoSistema/InputCheckBox';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import { WrapperLegendItens } from '../../../../../../components/NovoSistema/WrapperLegendItens';

export default function CadastroDeClienteAdd({ setOption }) {
  const [internalOption, setInternalOption] = useState('Principal');
  const [showOrHideDadosBancarios, setShowOrHideDadosBancarios] = useState(false);
  const [showOrHideCategorias, setShowOrHideCategorias] = useState(false);
  const [showOrHideIntegracaoCliente, setShowOrHideIntegracaoCliente] = useState(false);
  const [showOrHideIntegracaoFornecedor, setShowOrHideIntegracaoFornecedor] = useState(false);
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Principal"
          border="#333F50"
          active={internalOption === 'Principal' ? true : false}
          yourFunction={() => setInternalOption('Principal')}
        />
        <ButtonOptions
          buttonName="Endereço"
          border="#333F50"
          active={internalOption === 'Endereço' ? true : false}
          yourFunction={() => setInternalOption('Endereço')}
        />
        <ButtonOptions
          buttonName="Contato"
          border="#333F50"
          active={internalOption === 'Contato' ? true : false}
          yourFunction={() => setInternalOption('Contato')}
        />
        <ButtonOptions
          buttonName="Financeiro"
          border="#333F50"
          active={internalOption === 'Financeiro' ? true : false}
          yourFunction={() => setInternalOption('Financeiro')}
        />
        <ButtonOptions
          buttonName="Dados Complementares"
          border="#333F50"
          active={internalOption === 'Dados Complementares' ? true : false}
          yourFunction={() => setInternalOption('Dados Complementares')}
        />
        <ButtonOptions
          buttonName="Centro de Custo"
          border="#333F50"
          active={internalOption === 'Centro de Custo' ? true : false}
          yourFunction={() => setInternalOption('Centro de Custo')}
        />
        <ButtonOptions
          buttonName="Associado"
          border="#333F50"
          active={internalOption === 'Associado' ? true : false}
          yourFunction={() => setInternalOption('Associado')}
        />
      </HeaderButtons>
      {internalOption === 'Principal' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Situação" id="Situacao" widthPercentage="10%" />
                <InputText title="Código" id="Codigo" widthPercentage="10%" />
                <InputDate title="Data do Cadastro" id="DataDoCadastro" widthPercentage="20%" />
                <SelectAndOptions
                  title="* Tipo de Pessoa"
                  id="TipoDePessoa"
                  optionsArray={['', 'Física', 'Jurídica']}
                  widthPercentage="20%"
                />
                <InputText title="Origem" id="Origem" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="* Nome/Razão Social" id="NomeRazaoSocial" widthPercentage="40%" />
                <InputText title="* Apelido / Nome Fantasia" id="ApelidoNomeFantasia" widthPercentage="40%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="* CNPJ/CPF" id="CNPJ/CPF" widthPercentage="20%" />
                <ButtonImportRecFed />
                <InputText title="Identif. Estrangeiro" id="IdentifEstrangeiro" widthPercentage="20%" />
                <InputCheckBox title="Parceiro do Exterior" id="ParceiroDoExterior" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="* Inscrição Estadual" id="InscricaoEstadual" widthPercentage="20%" />
                <InputCheckBox title="Isento" id="Isento" />
                <InputCheckBox title="Não Contribuinte" id="NaoContribuinte" />
                <InputText title="Inscr. Suframa" id="InscrSuframa" widthPercentage="20%" />
                <InputText title="Inscr. Municipal" id="InscrMunicipal" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputCheckBox title="Produtor Rural" id="ProdutorRural" />
                <InputCheckBox title="Simples Nacional" id="SimplesNacional" />
                <InputText title="RG" id="RG" widthPercentage="15%" />
                <InputText title="Título de Eleitor" id="TituloDeEleitor" widthPercentage="15%" />
                <InputText title="Zona" id="Zona" widthPercentage="15%" />
                <InputText title="Seção" id="Secao" widthPercentage="15%" />
              </WrapperInputsNewSystem>
              <ContainerSection>
                <h3>Tipos de Cadastro</h3>
                <WrapperInputsNewSystem>
                  <InputCheckBox title="Cliente" id="Cliente" />
                  <InputCheckBox title="Fornecedor" id="Fornecedor" />
                  <InputCheckBox title="Fabricante" id="Fabricante" />
                  <InputCheckBox title="Transportadora" id="Transportadora" />
                  <InputCheckBox title="Outros" id="Outros" />
                </WrapperInputsNewSystem>
              </ContainerSection>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Grupo"
                  id="Grupo"
                  optionsArray={[
                    '',
                    'Grupos Educacionais',
                    'Gdes Empresas Prod Educ Apost',
                    'Edtechs',
                    'Gdes Empresas Responsab Social',
                    'Fundações e ONGs',
                    'Secretarias de Educação e Gov',
                    'Escola',
                    'Outros',
                    'Equipe',
                    'Fornecedores',
                    'Clientes',
                  ]}
                  widthPercentage="42%"
                />
                <ButtonsPlusAndCheck />
                <SelectAndOptions
                  title="Área"
                  id="Area"
                  optionsArray={[
                    '',
                    'Alimentos',
                    'Automotivos',
                    'Eletrônicos',
                    'Farmacêuticos',
                    'Materiais Construção',
                    'Móveis',
                    'Químicos',
                    'Têxtil',
                  ]}
                  widthPercentage="42%"
                />
                <ButtonsPlusAndCheck />
              </WrapperInputsNewSystem>
              <ContainerSection>
                <h3>E-mail / Telefone</h3>
                <WrapperInputsNewSystem>
                  <InputText title="Faturamento (xml)" id="FaturamentoXml" widthPercentage="40%" />
                  <InputText title="Financeiro (Boleto)" id="Financeiro (Boleto)" widthPercentage="40%" />
                </WrapperInputsNewSystem>
                <WrapperInputsNewSystem>
                  <InputText title="Telefone (xml)" id="TelefoneXml" widthPercentage="40%" />
                </WrapperInputsNewSystem>
              </ContainerSection>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Endereço' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Tipo Endereço"
                  id="TipoEndereco"
                  optionsArray={['', 'Principal', 'Entrega', 'Cobrança']}
                  widthPercentage="40%"
                />
                <InputText title="* CEP" id="CEP" widthPercentage="40%" />
                <ButtonsGeneric>
                  <button className="success">Pesquisar</button>
                </ButtonsGeneric>
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Tipo Logradouro"
                  id="TipoLogradouro"
                  optionsArray={[
                    '',
                    'Rua',
                    'Aeroporto',
                    'Avenida',
                    'Campo',
                    'Condomínio',
                    'Distrito',
                    'Núcleo',
                    'Pátio',
                    'Praça',
                    'Quadra',
                    'Residencial',
                    'Via',
                    'Outro',
                  ]}
                  widthPercentage="20%"
                />
                <InputText title="* Logradouro" id="Logradouro" widthPercentage="20%" />
                <InputText title="* Número" id="Numero" widthPercentage="20%" />
                <InputText title="* Bairro" id="Bairro" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Complemento" id="Complemento" widthPercentage="20%" />
                <SelectAndOptions
                  title="* País"
                  id="Pais"
                  optionsArray={['', 'BRASIL', 'EUA', 'CANADA', 'CHINA', 'RUSSIA', 'ESPANHA', 'JAPÃO', 'KOREIA DO SUL']}
                  widthPercentage="20%"
                />
                <SelectAndOptions
                  title="* UF"
                  id="UF"
                  optionsArray={[
                    '',
                    'AC',
                    'AL',
                    'AP',
                    'AM',
                    'BA',
                    'CE',
                    'DF',
                    'ES',
                    'GO',
                    'MA',
                    'MT',
                    'MS',
                    'MG',
                    'PA',
                    'PB',
                    'PR',
                    'PE',
                    'PI',
                    'RJ',
                    'RN',
                    'RS',
                    'RO',
                    'RR',
                    'SC',
                    'SP',
                    'SE',
                    'TO',
                  ]}
                  widthPercentage="20%"
                />
                <SelectAndOptions
                  title="* Município"
                  id="Municipio"
                  optionsArray={['', 'Outros']}
                  widthPercentage="20%"
                />
              </WrapperInputsNewSystem>
              <ButtonsGeneric>
                <button className="success">Mapa</button>
                <button className="success">+ Adicionar</button>
              </ButtonsGeneric>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Contato' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="* Nome" id="Nome" widthPercentage="40%" />
                <InputText title="Cargo" id="Cargo" widthPercentage="20%" />
                <InputText title="Departamento" id="Departamento" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Sexo"
                  id="Sexo"
                  optionsArray={['', 'Masculino', 'Feminino']}
                  widthPercentage="20%"
                />
                <SelectAndOptions
                  title="Estado Civil"
                  id="EstadoCivil"
                  optionsArray={[
                    '',
                    'Solteiro(a)',
                    'Casado(a)',
                    'Divorciado(a)',
                    'Viúvo(a)',
                    'Separado(a)',
                    'Companheiro(a)',
                  ]}
                  widthPercentage="20%"
                />
                <InputDate title="Data de Nascimento" id="DataDeNascimento" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Telefone" id="Telefone" widthPercentage="20%" />
                <SelectAndOptions
                  title=""
                  id="TipoTelefone"
                  optionsArray={['', 'Celular', 'Comercial', 'Residencial', 'Fax', 'Outros']}
                  widthPercentage="20%"
                />
                <InputText title="E-mail" id="E-mail" widthPercentage="20%" />
                <SelectAndOptions
                  title="Processo"
                  id="Processo"
                  optionsArray={[
                    '',
                    'Cobrança',
                    'CCotação / Pedido de Compra',
                    'Orçamento de Vendas',
                    'Pedido de Vendas',
                  ]}
                  widthPercentage="20%"
                />
              </WrapperInputsNewSystem>
              <ButtonsGeneric>
                <button className="success">+ Adicionar</button>
              </ButtonsGeneric>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Financeiro' && (
        <div>
          <ContainerSection>
            <h3 onClick={() => setShowOrHideDadosBancarios((e) => !e)}>
              {showOrHideDadosBancarios ? '-  ' : '+ '}Dados Bancários
            </h3>
            {showOrHideDadosBancarios && (
              <div>
                <WrapperInputsNewSystem>
                  <SelectAndOptions
                    title="Cond. Pagamento"
                    id="CondPagamento"
                    optionsArray={['', 'Novo...', 'à vista', '30 dias', '30/60 dias', '30/60/90 dias']}
                    widthPercentage="30%"
                  />
                  <SelectAndOptions
                    title="Forma Pagamento"
                    id="FormaPagamento"
                    optionsArray={[
                      '',
                      'Novo...',
                      'Dinheiro',
                      'Cheque',
                      'Cartão Crédito',
                      'Cartão Débito',
                      'Transferência DOC',
                      'Transferência TED',
                      'Boleto',
                      'Voucher',
                      'Troca',
                      'Conta',
                      'Débito Automático',
                    ]}
                    widthPercentage="30%"
                  />
                  <SelectAndOptions
                    title="Tipo de Conta"
                    id="TipoDeConta"
                    optionsArray={['', 'Conta Corrente', 'Poupança']}
                    widthPercentage="30%"
                  />
                </WrapperInputsNewSystem>
                <WrapperInputsNewSystem>
                  <DoubleInput title="Banco" id="Banco" widthPercentage="30%" />
                  <InputText title="Agência" id="Agencia" widthPercentage="20%" />
                  <InputText title="DV" id="DVAgencia" widthPercentage="5%" />
                  <InputText title="Conta" id="Conta" widthPercentage="20%" />
                  <InputText title="DV" id="DVConta" widthPercentage="5%" />
                </WrapperInputsNewSystem>
                <WrapperInputsNewSystem>
                  <InputText title="Cód. Débito Automático" id="CodDebitoAutomatico" widthPercentage="30%" />
                  <SelectAndOptions
                    title="Tipo de Chave Pix"
                    id="TipoDeChavePix"
                    optionsArray={['']}
                    widthPercentage="30%"
                  />
                  <InputText title="Chave Pix" id="ChavePix" widthPercentage="30%" />
                </WrapperInputsNewSystem>
              </div>
            )}
          </ContainerSection>
          <ContainerSection>
            <h3 onClick={() => setShowOrHideCategorias((e) => !e)}>{showOrHideCategorias ? '-  ' : '+ '}Categorias</h3>
            {showOrHideCategorias && (
              <div>
                <WrapperInputsNewSystem>
                  <SelectAndOptions title="Cliente" id="Cliente" optionsArray={['']} widthPercentage="45%" />
                  <SelectAndOptions title="Fornecedor" id="Fornecedor" optionsArray={['']} widthPercentage="45%" />
                </WrapperInputsNewSystem>
                <WrapperInputsNewSystem>
                  <SelectAndOptions title="Fabricante" id="Fabricante" optionsArray={['']} widthPercentage="45%" />
                  <SelectAndOptions
                    title="Transportadora"
                    id="Transportadora"
                    optionsArray={['']}
                    widthPercentage="45%"
                  />
                </WrapperInputsNewSystem>
              </div>
            )}
          </ContainerSection>
          <ContainerSection>
            <h3 onClick={() => setShowOrHideIntegracaoCliente((e) => !e)}>
              {showOrHideIntegracaoCliente ? '-  ' : '+ '}Integração Cliente
            </h3>
            {showOrHideIntegracaoCliente && (
              <div>
                <WrapperInputsNewSystem>
                  <SelectAndOptions
                    title="Conta Contábil Cliente"
                    id="ContaContabilCliente"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                  <SelectAndOptions
                    title="Conta Contábil Multa"
                    id="ContaContabilMulta"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                </WrapperInputsNewSystem>
                <WrapperInputsNewSystem>
                  <SelectAndOptions
                    title="Conta Contábil Juros"
                    id="ContaContabilJuros"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                  <SelectAndOptions
                    title="Conta Contábil Desconto"
                    id="ContaContabilDesconto"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                </WrapperInputsNewSystem>
                <WrapperInputsNewSystem>
                  <SelectAndOptions
                    title="Conta Contábil Acréscimo"
                    id="ContaContabilAcrescimo"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                </WrapperInputsNewSystem>
              </div>
            )}
          </ContainerSection>
          <ContainerSection>
            <h3 onClick={() => setShowOrHideIntegracaoFornecedor((e) => !e)}>
              {showOrHideIntegracaoFornecedor ? '-  ' : '+ '}Integração Fornecedor
            </h3>
            {showOrHideIntegracaoFornecedor && (
              <div>
                <WrapperInputsNewSystem>
                  <SelectAndOptions
                    title="Conta Contábil Fornecedor"
                    id="ContaContabilFornecedor"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                  <SelectAndOptions
                    title="Conta Contábil Multa"
                    id="ContaContabilMulta"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                </WrapperInputsNewSystem>
                <WrapperInputsNewSystem>
                  <SelectAndOptions
                    title="Conta Contábil Juros"
                    id="ContaContabilJuros"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                  <SelectAndOptions
                    title="Conta Contábil Desconto"
                    id="ContaContabilDesconto"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                </WrapperInputsNewSystem>
                <WrapperInputsNewSystem>
                  <SelectAndOptions
                    title="Conta Contábil Acréscimo"
                    id="ContaContabilAcrescimo"
                    optionsArray={[
                      '',
                      '1.0.00.00.00000 / ATIVO',
                      '1.1.00.00.00000 / ATIVO CIRCULANTE',
                      '1.1.01.00.00000 / DISPONÍVEL',
                      '1.1.01.01.00000 / CAIXA GERAL',
                    ]}
                    widthPercentage="45%"
                  />
                </WrapperInputsNewSystem>
              </div>
            )}
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Dados Complementares' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <DoubleInput title="Transportador" id="Transportador" widthPercentage="45%" />
                <DoubleInput title="Vendedor" id="Vendedor" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="% Comissão" id="Comissao" widthPercentage="45%" />
                <InputText title="Limite de Consumo" id="LimiteDeConsumo" widthPercentage="45%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Observações Gerais" id="ObservacoesGerais" widthPercentage="100%" />
              </WrapperInputsNewSystem>
              <ContainerSection>
                <h3>Alerta Usuário</h3>
                <div>
                  <WrapperInputsNewSystem>
                    <InputCheckBox title="Alertar Usuários" id="AlertarUsuarios" />
                  </WrapperInputsNewSystem>
                  <WrapperInputsNewSystem>
                    <SelectAndOptions title="Processo" id="Processo" optionsArray={['']} widthPercentage="20%" />
                    <InputText title="Mensagem" id="Mensagem" widthPercentage="75%" />
                  </WrapperInputsNewSystem>
                </div>
              </ContainerSection>
              <ContainerSection>
                <div>
                  <h3>Anexar Arquivos</h3>
                  <WrapperLegendItens>
                    <input type="file" name="attachments" id="attachments" />
                  </WrapperLegendItens>
                </div>
              </ContainerSection>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Centro de Custo' && (
        <div>
          <ContainerSection>
            <h3>Rateio Cliente</h3>
            <WrapperInputsNewSystem>
              <InputText title="Centro de Custos" id="CentroDeCustosCliente" widthPercentage="20%" />
              <InputText title="Descrição" id="DescricaoCliente" widthPercentage="40%" />
              <InputText title="" id="ContDescricaoCliente" widthPercentage="30%" />
            </WrapperInputsNewSystem>
            <ButtonsGeneric>
              <button className="success">+ Adicionar</button>
            </ButtonsGeneric>
          </ContainerSection>
          <ContainerSection>
            <h3>Rateio Fornecedor</h3>
            <WrapperInputsNewSystem>
              <InputText title="Centro de Custos" id="CentroDeCustosFornecedor" widthPercentage="20%" />
              <InputText title="Descrição" id="DescricaoFornecedor" widthPercentage="40%" />
              <InputText title="" id="ContDescricaoFornecedor" widthPercentage="30%" />
            </WrapperInputsNewSystem>
            <ButtonsGeneric>
              <button className="success">+ Adicionar</button>
            </ButtonsGeneric>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Associado' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Matrícula" id="Matricula" widthPercentage="20%" />
                <SelectAndOptions
                  title="Tipo"
                  id="Tipo"
                  optionsArray={['', 'Efetivo', 'Colaborador', 'Padrinho']}
                  widthPercentage="20%"
                />
                <InputText title="Valor Contribuição" id="ValorContribuicao" widthPercentage="20%" />
                <SelectAndOptions
                  title="Forma Contribuição"
                  id="FormaContribuicao"
                  optionsArray={['', 'Mensal', 'Bimestral', 'Trimestral', 'Semestral', 'Esporádico', 'Anual']}
                  widthPercentage="20%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Dia Vencimento" id="DiaVencimento" widthPercentage="13%" />
                <InputDate title="Data Reajuste" id="DataReajuste" widthPercentage="13%" />
                <InputDate title="Data Cancelamento" id="DataCancelamento" widthPercentage="13%" />
                <SelectAndOptions
                  title="Motivo Cancelamento"
                  id="MotivoCancelamento"
                  optionsArray={[
                    '',
                    'Falecimento',
                    'Não contribui a 6 meses',
                    'Outros',
                    'Restrições Bancárias',
                    'Saldo Insufic p/ DEB AUTO',
                  ]}
                  widthPercentage="30%"
                />
                <ButtonsPlusAndCheck />
                <InputDate title="Data Ultimo Lote" id="DataUltimoLote" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Tipo Deficiência"
                  id="TipoDeficiencia"
                  optionsArray={['', 'Deficiência Auditivo', 'Deficiência Físico', 'Deficiência Intelectual']}
                  widthPercentage="40%"
                />
                <SelectAndOptions
                  title="Parentesco"
                  id="Parentesco"
                  optionsArray={['', 'ESPOSO(A)', 'FILHO(A)', 'NETO(A)', 'O PROPRIO', 'PAI/MÃE']}
                  widthPercentage="30%"
                />
                <ButtonsPlusAndCheck />
                <InputText title="Mês Referência" id="MesReferencia" widthPercentage="20%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
